/**
 * privacy-policy-hash-nav.js
 * Legends Global -- Shopify Plus / Dawn theme
 *
 * 1. Opens any <details class="policy-section"> ancestor when navigating
 *    to an anchor link inside it (TOC clicks, AdChoices footer link,
 *    inline cross-reference links).
 * 2. Substitutes touVars values into data-tou-var elements on DOMContentLoaded.
 *
 * INSTALLATION:
 *   1. Fill in all touVars values below before uploading.
 *   2. Upload to theme Assets folder (not Settings > Files).
 *   3. In sections/main-page.liquid, just before {% schema %}:
 *      <script src="{{ 'privacy-policy-hash-nav.js' | asset_url }}" defer></script>
 *
 * Values sourced from: LGM e-Commerce Content Links.xlsx (Privacy Office SharePoint)
 */

/**
 * -- TEMPLATE VARIABLES -------------------------------------------------------
 * Fill in each value before uploading. Leave blank to show fallback placeholder.
 */
var touVars = {
  LAST_UPDATED: 'May 26, 2026',       // e.g. "March 15, 2026"
  STORE_NAME: 'Miami Team Store',         // e.g. "BNP Paribas Open Shop"
  CORPORATE_NAME: 'Miami Team Store',     // e.g. "Legends Global Merchandise, LLC"
  CS_EMAIL: 'shop@miamihts.com',           // e.g. "support@store.com" -- used as mailto: href and link text
  PRIVACY_NOTICE_URL: '/pages/privacy-notice', // e.g. "/pages/privacy-notice"
  RETURNS_POLICY_URL: '/pages/shipping-returns', // e.g. "/pages/shipping-returns"
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-tou-var]').forEach(function (el) {
    var key = el.getAttribute('data-tou-var');
    var val = touVars[key];
    if (!val) return;
    if (el.tagName === 'A') {
      el.href = (key === 'CS_EMAIL') ? 'mailto:' + val : val;
      el.textContent = (key === 'CS_EMAIL') ? val : el.textContent;
    } else {
      el.textContent = val;
    }
  });
});

(function () {
  function openAncestorDetails(hash) {
    if (!hash) return;
    var target = document.getElementById(hash.replace(/^#/, ''));
    if (!target) return;
    var el = target.parentElement;
    while (el && el !== document.body) {
      if (el.tagName === 'DETAILS') el.open = true;
      el = el.parentElement;
    }
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (window.location.hash) {
    setTimeout(function () { openAncestorDetails(window.location.hash); }, 50);
  }

  window.addEventListener('hashchange', function () {
    openAncestorDetails(window.location.hash);
  });
})();